import request from '@/utils/request'


// 查询设备监控视频列表
export function listVideo(query) {
  return request({
    url: '/mibo/device-video/list',
    method: 'get',
    params: query
  })
}

// 查询设备监控视频分页
export function pageVideo(query) {
  return request({
    url: '/mibo/device-video/page',
    method: 'get',
    params: query
  })
}

// 查询设备监控视频详细
export function getVideo(data) {
  return request({
    url: '/mibo/device-video/detail',
    method: 'get',
    params: data
  })
}

// 新增设备监控视频
export function addVideo(data) {
  return request({
    url: '/mibo/device-video/add',
    method: 'post',
    data: data
  })
}

// 修改设备监控视频
export function updateVideo(data) {
  return request({
    url: '/mibo/device-video/edit',
    method: 'post',
    data: data
  })
}

// 删除设备监控视频
export function delVideo(data) {
  return request({
    url: '/mibo/device-video/delete',
    method: 'post',
    data: data
  })
}
